var subDomain = "api";
if (window.location.host != "www.myptmyra.com" && window.location.host != "myptmyra.com" && window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
  subDomain = "uatapi";
}

export const ajaxLink = "https://" + subDomain + ".virdiohealth.com/api/v1";

export const IS_UAT = window.location.hostname.includes("uat") || window.location.hostname.includes("weborik") || window.location.hostname.startsWith("virdio-ar");